import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './theme.css';
import './kit/kit.css';
import { temayiUygula } from './tema';
import { ConfirmationProvider } from './ui';
import { GerekceSaglayici } from './kit/kit';

// Tema ilk çizimden önce (açılışta yanlış renk yanıp sönmesin)
temayiUygula();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfirmationProvider>
      <GerekceSaglayici>
        <App />
      </GerekceSaglayici>
    </ConfirmationProvider>
  </StrictMode>,
);
